module.exports = __webpack_public_path__ + "static/media/Cats Eyes 09_SPANSKA-mixdown.2d967d7c.mp3";